import axios from "axios";
import config from "../config";
import { extractDataFromArray, parseResponseAxios } from "../utils/common";



const SearchService = {
    search: async (searchType,kw, at, sp, sb, start, limit, lt, ln, r, d1, d2,mnd,mxd, mnp, mxp,eat, callback = () => { }) => {
        await axios.get(config.apiUrl + "/services/openapi", {
            params: {
                cmd: "search",
                kw,
                at: at === 'A' ? '' : at,
                sp,
                sb,
                start,
                limit,
                lt,
                ln,
                r,
                d1,
                d2,
                type:searchType,
                mnd,
                mxd,
                mnp,
                mxp,
                eat
            }
        }).then((response) => {
            response = parseResponseAxios(response)
            if (extractDataFromArray(response, ['errorCode'], 0) === 0) {
                callback(extractDataFromArray(response, ['data'], []))
            }
        });
    },
    getActivityType: async(callback = () => { }) => {
        await axios.get(config.apiUrl + "/services/openapi", {
            params: {
                cmd: "getActivityDisplayStrings",
            }
        }).then((response) => {
            response = parseResponseAxios(response)
            if (extractDataFromArray(response, ['errorCode'], 0) === 0) {
                callback(extractDataFromArray(response, ['data'], []))
            }
        });
    },
    getAllActivitiesDetails: async(callback = () => { }) => {
        await axios.get(config.apiUrl + "/services/openapi", {
            params: {
                cmd: "getAllActivitiesDetails",
            }
        }).then((response) => {
            response = parseResponseAxios(response)
            if (extractDataFromArray(response, ['errorCode'], 0) === 0) {
                callback(extractDataFromArray(response, ['data'], []))
            }
        });
    }
}

export default SearchService;